const SF85 = 'SF85';
const SF85P = 'SF85P';
const SF852013 = 'SF852013';
const SF86 = 'SF86';
const SF85PS = 'SF85P+85P-S';
const PVQ_A = 'PVQ-A';
const PVQ_A_B = 'PVQ-A-B';
const PVQ_A_B_C = 'PVQ-A-B-C';
const PVQ_A_B_D = 'PVQ-A-B-D';

export type FormTypes = typeof SF85 | typeof SF85P | typeof SF86 | typeof SF852013 | typeof SF85PS |
 typeof PVQ_A | typeof PVQ_A_B | typeof PVQ_A_B_C | typeof PVQ_A_B_D;

export {
  SF85, SF85P, SF86, SF852013, SF85PS, PVQ_A, PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D
};
